module.exports = __webpack_public_path__ + "img/btn6-2.761a0dce.png";